import React, { useState } from 'react';

const SafeImage = ({ src, alt, className, fallbackSrc = '/images/property-placeholder.svg' }) => {
  const [error, setError] = useState(false);

  return (
    <img
      src={error ? fallbackSrc : src}
      alt={alt}
      className={className}
      onError={() => setError(true)}
      loading="lazy"
    />
  );
};

export default SafeImage;